
const AppConfig = {
    // 线上地址
    INTER_BASE:"//service.awards.topdigitalworld.com/index.php",
    INTER_IMPORT_CASE:"//service.awards.topdigitalworld.com/index.php?f=A_uploadCase&token=",//案例导入
    INTER_IMPORT_RATER:"//service.awards.topdigitalworld.com/index.php?f=A_uploadJudges&token=",//评委导入

    // INTER_BASE:"//api.awards.topdigitalworld.com/index.php",
    // INTER_IMPORT_CASE:"//api.awards.topdigitalworld.com/index.php?f=A_uploadCase&token=",//案例导入
    // INTER_IMPORT_RATER:"//api.awards.topdigitalworld.com/index.php?f=A_uploadJudges&token=",//评委导入
    // 测试地址
    // INTER_BASE:"https://wxapp.kuaipantech.com/TopDigital/index.php",
    // INTER_IMPORT_CASE:"https://wxapp.kuaipantech.com/TopDigital/index.php?f=A_uploadCase&token=",//案例导入
    // INTER_IMPORT_RATER:"https://wxapp.kuaipantech.com/TopDigital/index.php?f=A_uploadJudges&token=",//案例导入
    // USER_PREVIEW_ADDTC:"http://dev.topdigital.kuaipantech.com/#/enter/detail/?id="
    // USER_PREVIEW_ADDTC:"http://localhost:3081/#/enter/detail/?id="
}


export default AppConfig;